import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/yimo-img/phone-ai.png'
import _imports_1 from '../../assets/img/yimo-img/linkyimo-ai.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-8530acf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "next" }, null, -1))
const _hoisted_2 = { class: "Page-two" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "phone",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "linkyimo",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["box2 animate__faster", {
        animate__animated: _ctx.nowPage === 3,
        animate__fadeInLeft: _ctx.nowPage === 3
      }])
      }, _hoisted_4, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["box3 animate__faster", {
        animate__animated: _ctx.nowPage === 3,
        animate__fadeInRight: _ctx.nowPage === 3
      }])
      }, [
        _hoisted_5,
        _createElementVNode("div", {
          class: _normalizeClass(["pageOneWord animate_fast", {
          animate__animated: _ctx.nowPage === 3,
          animate__fadeInRight: _ctx.nowPage === 3
        }])
        }, [
          _createTextVNode(" 我们想赋予你爱与梦想的名义，去披荆斩棘，去乘风破浪！"),
          _hoisted_6,
          _createTextVNode(" 在这个充满无限可能的虚拟世界，你可以打造属于您自己的独特Avatar "),
          _hoisted_7,
          _createTextVNode("虚拟形象，尽情展现个性！"),
          _hoisted_8,
          _createTextVNode(" 在这里你可以是元世界的女主角、豪门千金、文艺才女、毒蛇总裁、 高冷富二代、温柔奶狗..... ")
        ], 2)
      ], 2)
    ])
  ], 64))
}